import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Header from './Header';
import FingoNavbar from './FingoNavbar';

const Layout = ({ whiteBGC, NavbarComponent, children, defaultBackgroundColor }) => {
  const location = useLocation();

  const backgroundColor = useMemo(() => {
    if (whiteBGC.includes(location.pathname)) {
      return 'common.white';
    }
    return defaultBackgroundColor;
  }, [location.pathname.split('/')[1]]);

  return (
    <Stack height={1}>
      <Header NavbarComponent={NavbarComponent} />
      <Box bgcolor={backgroundColor} flexGrow={1}>
        {children}
      </Box>
    </Stack>
  );
};

Layout.propTypes = {
  whiteBGC: PropTypes.arrayOf(PropTypes.string),
  NavbarComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  children: PropTypes.element.isRequired,
  defaultBackgroundColor: PropTypes.string,
};

Layout.defaultProps = {
  whiteBGC: [],
  NavbarComponent: FingoNavbar,
  defaultBackgroundColor: 'gray.A200',
};

export default Layout;
